import { combineReducers } from 'redux'
import taskPanel from 'features/taskPanel/store/reducer'
import notifications from 'features/notifications/store/reducer'
import popup from 'features/popup/store/reducer'
import progressBar from 'features/progressBar/store/reducer'
import session from 'features/session/store/reducer'
import teamlist from 'features/teamlist/store/reducer'
import todolist from 'features/todolist/store/reducer'
import { Snackbar } from 'gipsy-ui'

const allReducers = combineReducers({
  taskPanel,
  notifications,
  popup,
  progressBar,
  session,
  teamlist,
  todolist,
  snackbar: Snackbar.reducer
})

/* add the ability to reset the store (usefull for tests) */
const rootReducer = (state, action) => {
  if (action.type === 'RESET_APP') {
    state = undefined
  }

  return allReducers(state, action)
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers.js